export default function IndustryProblem() {
  return (
    <section className="py-20 md:py-32 bg-[#F5F5F5] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(45deg, #1A2B4A 0, #1A2B4A 1px, transparent 0, transparent 50%)`,
          backgroundSize: '10px 10px',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="mb-12">
          <div className="flex items-start gap-4">
            <div className="w-1.5 h-24 bg-[#D4AF37] flex-shrink-0"></div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#1A2B4A] leading-tight font-serif">
              なぜ他社では成立しないのか<br />
              <span className="text-2xl md:text-3xl font-serif">大手金融機関がこの市場から「撤退」せざるを得なかった理由</span>
            </h2>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-5xl">
          <div className="bg-white p-10 md:p-12 rounded-3xl shadow-xl relative">
            {/* Warning Icon */}
            <div className="absolute -top-6 -right-6 w-20 h-20 flex items-center justify-center bg-[#D4AF37] rounded-full shadow-lg">
              <i className="ri-alert-line text-white text-4xl"></i>
            </div>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed font-serif">
              <p>
                低与信者向けの車両リースは、一見すると利回りが高く魅力的に見えます。しかし、実態は過酷です。
              </p>
              <p>
                一般的な参入者が直面するのは、<span className="text-[#1A2B4A] font-bold text-xl">10〜30%にも及ぶ高い延滞率</span>と、それに伴う膨大な回収コスト、そして顧客とのトラブルによるキャッシュフローの崩壊です。
              </p>
              <p className="text-xl font-bold text-[#1A2B4A] bg-[#FFF8E1] p-6 rounded-xl border-l-4 border-[#D4AF37]">
                「リスクが高すぎて事業として成立しない」——。これが大手金融機関やディーラーが出した結論です。
              </p>
              <p>
                彼らが<span className="text-[#1A2B4A] font-bold">撤退</span>し、二度と戻ってこないからこそ、この市場は「特殊なノウハウ」を持つ者だけの<span className="text-[#D4AF37] font-bold text-xl">ブルーオーシャン</span>となっているのです。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
